export class Currency {

    constructor(
        public id: number,
        public name: string,
        public isoCode: string,
        public symbol: string
    ){}
}
